import { ADMIN_CREATE_USER_UPDATE } from './adminUsersMapProps'

export interface IAdminUsersState {
  createUserStatus: { success: boolean; message: string }
}

const initialState: IAdminUsersState = {
  createUserStatus: {
    success: false,
    message: '',
  },
}
export function adminUsersReducer(
  state: IAdminUsersState = initialState,
  action: any,
): IAdminUsersState {
  switch (action.type) {
    case ADMIN_CREATE_USER_UPDATE:
      return { ...state, createUserStatus: action.payload }
    default:
      return state
  }
}
